var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.036 3.98-6.269 6.252a.32.32 0 0 0-.096.234l-.547 2.521a.32.32 0 0 0 .322.325l2.534-.584a.3.3 0 0 0 .225-.097l6.251-6.23-2.42-2.42zm3.129 1.715.749-.747a1.712 1.712 0 1 0-2.417-2.425l-.753.751 2.42 2.421z",
    fill: "#BE69C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon_pencil.83e9518d340264a6391666bbf899642c.svg";
export { ForwardRef as ReactComponent };